<div class="main-tab-title-box">
  <mat-card-title class="main-title">Lexical Diversity</mat-card-title>
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2  && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<mat-card-content>
  <div *ngIf="lexical_short_words" class="message">
    <div class="line"></div>
    <p>Lexical scores are not accurate on short documents.</p>
  </div>
  <span class="main-box-title-14">This tool gives you different measures of Lexical Diversity, which is an indication of the diversity of words used in your text. For more detailed information on the meaning of these Lexical Diversity measures go <a href="https://textinspector.com/help/lexical-diversity/" class="hiperlinks" target="_blank" rel="noopener noreferrer">here</a>.</span>

  <div class="readability-box">
    <div class="readability-box-sub">
      <div class="main-box-title-16">VOCD <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">
Introduced in the early 2000s to provide a more stable estimate of lexical diversity. It uses statistical modeling to handle variations in text length and sample size, making it a trusted tool in linguistic and psycholinguistic research. [Malvern et al., 2004]</span>
        </div>
      </div>
      <div class="main-box-value-32">{{diversity.vocd}}</div>
    </div>
    <div class="readability-box-sub margin-box-title">
      <div class="main-box-title-12">Low vocabulary diversity</div>
      <div class="main-box-title-12">High vocabulary diversity</div>
    </div>
    <div class="readability-box-sub margin-box-number">
      <div class="main-box-title-12">0</div>
      <div class="main-box-title-12">180</div>
    </div>
    <div class="readability-box-sub padding-line">
      <mat-progress-bar mode="determinate" [value]="(diversity.vocd ?? 0) / 180 * 100"
        color="accent"></mat-progress-bar>
    </div>
    <div class="readability-box-sub">
      <div class="main-box-title-12">
Put simply, a higher number roughly corresponds to a wider range of words being utilised. VOCD scores are typically between 0 and 200, with a conversion chart below indicating what your score might mean in a given context.
<br>
<br>
VOCD is a complex measure which takes smaller subsamples at random, usually around 50 words, and then calculates the average type-token ratio (TTR). It also involves a curve fitting process. You can find more details <a href="https://textinspector.com/help/lexical-diversity/" class="hiperlinks2" target="_blank" rel="noopener noreferrer">here</a>.
      </div>
    </div>
    <div *ngIf="diversity.vocd !== null && diversity.vocd !== undefined"
      [ngClass]="getBoxLineColorVOCD(diversity.vocd)">
      <div class="main-box-title-12">{{ getTextLineVOCD(diversity.vocd) }}</div>
    </div>
  </div>

  <div class="readability-box">
    <div class="readability-box-sub">
      <div class="main-box-title-16">MTLD<div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">
Developed in 2010 as a more reliable alternative to older vocabulary measures like TTR. Designed to reduce the impact of text length on results, now widely used in linguistics and language assessment for more accurate insight into vocabulary use. [McCarthy & Jarvis, 2010]</span>
        </div>
      </div>
      <div class="main-box-value-32">{{diversity.mtld}}</div>
    </div>
    <div class="readability-box-sub margin-box-title">
      <div class="main-box-title-12">Low vocabulary diversity</div>
      <div class="main-box-title-12">High vocabulary diversity</div>
    </div>
    <div class="readability-box-sub margin-box-number">
      <div class="main-box-title-12">0</div>
      <div class="main-box-title-12">180</div>
    </div>
    <div class="readability-box-sub padding-line">
      <mat-progress-bar mode="determinate" [value]="(diversity.mtld ?? 0) / 180 * 100"
        color="accent"></mat-progress-bar>
    </div>
    <div class="readability-box-sub">
      <div class="main-box-title-12">
Put simply, a higher number roughly corresponds to a wider range of words being utilised. MTLD scores are typically between 0 and 200, with a conversion chart below indicating what your score might mean in a given context.
<br>
<br>
MTLD considers the original order of words in the sample. It is based on the type-token ratio (TTR), which you can find in the statistics section. This method calculates the average length of segments that have a certain TTR, and is carried out twice: once from left to right, and then the other in reverse. These results are then averaged. You can find more details <a href="https://textinspector.com/help/lexical-diversity/" class="hiperlinks2" target="_blank" rel="noopener noreferrer">here</a>.
      </div>
    </div>
    <div *ngIf="diversity.mtld !== null && diversity.mtld !== undefined"
      [ngClass]="getBoxLineColorMTLD(diversity.mtld)">
      <div class="main-box-title-12">{{ getTextLineMTLD(diversity.mtld) }}</div>
    </div>
  </div>
  <div class="readability-box padding-chart">
    <canvas id="myChart" width="1000" height="700"></canvas>
  </div>
</mat-card-content>
<div style="display: flex; text-align: center;">
  <div class="main-box-title-12">Means and sub-ranges (10th-90th percentiles) of D for various cohorts, from Duran, Malvern, Richards, Chipere 2004: 238.
  </div>
</div>